import React, { useState, useContext } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import Context from '../../Context/context';

function ModalDetailProduct(props) {
  const { showFrais, toggleShowFrais } = props;
  const { productsPanier ,frais_global , setFraisGlobal } = useContext(Context);
  const [frais, setFrais] = useState(frais_global);

  // This function could be used to handle form submission
  const handleSubmit = async (e) => {
    setFraisGlobal(frais)
    toggleShowFrais()

  };

  return (
    <Modal
      
      show={showFrais}
      onHide={toggleShowFrais}
      aria-labelledby="modal-frais-livraison"
      className='modal-detail-product'
    >
      <div>
        <Modal.Header closeButton>
          <Modal.Title id="modal-frais-livraison">
            Ajouter des frais de livraison
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group controlId="fraisForm">
            <Form.Label>Frais de livraison :</Form.Label>
            <Form.Control
              type="number"
              placeholder="Entrez les frais de livraison"
              value={frais}
              onChange={e => setFrais(parseFloat(e.target.value) || 0)}
              required
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={toggleShowFrais}>
            Fermer
          </Button>
          <Button variant="primary" onClick={handleSubmit} type="submit" disabled={!frais}>
            Enregistrer
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  );
}

export default ModalDetailProduct;
